import { useEffect, useState } from 'react';

// useClient is a custom hook to detect if the component has been mounted on the client side.
export function useClient() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  return mounted;
}
